import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Icons from '../../../../../common/widgets/Icons';
import { resources } from '../../../resources/resources';

export default function MyCards() {
  const { t: translate } = useTranslation();
  const navigateTo = useNavigate();

  return (
    <div className="product-my-cards">
      <div className="product-my-cards-copy">
        {translate(resources.products.myCardsMessage)}
      </div>
      <div className="product-my-cards-footer">
        <div className="product-my-cards-action">
          <button
            className="btn-link"
            onClick={() => {
              navigateTo('/my-account/cards');
            }}
          >
            <span className="btn-icon">
              <Icons.ArrowButton />
            </span>
            <span className="btn-text">{translate(resources.cards)}</span>
          </button>
        </div>
        <div className="product-my-cards-img"></div>
      </div>
    </div>
  );
}
